<template>
    <section v-if="product.Product != undefined  && product.Product.CloudinaryImagesToPartnumbers.length > 0" :aria-label="product.Product.Name + ' carousel'" id="image-and-video-section" :class="{ 'show-video-hide-image' : enableCustomVideoImageSwitch }">

        <div id="mainImage">

            <button class="trigger-first-thumb-click">
                <picture>
                    <!--<source media="(max-width: 768px)" :srcset="activeImage.CloudinaryImage.ImageUrlMain">-->
                    <img class="img-responsive" :src="activeImage.CloudinaryImage.ImageUrlLarge" :srcset="activeImage.CloudinaryImage.ImageUrlMain + ' 768w,' + activeImage.CloudinaryImage.ImageUrlLarge + ' 1199w,'" v-on:click="openGallery()" fetchpriority="high">
                </picture>
                <!--<img class="img-responsive" :src="activeImage.CloudinaryImage.ImageUrlLarge" v-on:click="openGallery()" />-->
                <!--
    SK: old lightboxed
    <img class="lightboxed img-responsive"
     rel="group1"
     :src="activeImage.CloudinaryImage.ImageUrlLarge"
     :data-link="activeImage.CloudinaryImage.ImageUrlLarge"
     :alt="activeImage.CloudinaryImage.Description"
     :data-caption="activeImage.CloudinaryImage.Description" />
    -->

                <template v-for="addon in product.Product.AddOns" :key="addon">
                    <img :src="addon.CloudinaryImageOverlay.ImageUrlZoomTransparent" class="img-responsive addon-overlayimage" :class="{ 'selected' : addon.IsSelected || hasProductInCart(addon.GearGlobalProductId) }" />
                </template>
            </button>
        </div>

        <!-- langma video for france -->
        <div id="mainVideo" v-if="enableCustomVideoImageSwitch">
            <div class="bike-wistia-embed" style="position:relative;">
                <div class="wistia_responsive_padding" style="padding:75% 0 0 0; position: relative;">
                    <div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;z-index:200">
                        <iframe src="https://fast.wistia.net/embed/iframe/x5ne2qnm8k?videoFoam=true" allowtransparency="true" frameborder="0" scrolling="no" class="wistia_embed" name="wistia_embed" allowfullscreen mozallowfullscreen="true" webkitallowfullscreen="true" oallowfullscreen="true" msallowfullscreen="true" width="100%" height="100%"></iframe>
                    </div>
                </div>
            </div>
        </div>
        <!-- // -->

    </section>
    <!-- legacy images -->
    <section v-else-if="product.Product != undefined && product.Product.Image.length > 0">
        <div id="mainImage" style="min-height:0;">
            <img class="lightboxed img-responsive" :src="product.Product.Image" />
        </div>
    </section>

    <!-- langma video for france -->
    <div id="custom-thumbs" style="text-align: center;margin-top:15px;" v-if="enableCustomVideoImageSwitch">
        <a v-on:click="showBundleVideoOrImage('video')"><img src="https://res.cloudinary.com/dvtkqsmh4/images/b_white,c_fill,w_80,h_60,q_80/ufh0zvppu73edy2tsnle/thumb.jpg" class="img-responsive" /></a>
        <a v-on:click="showBundleVideoOrImage('image')"><img src="https://res.cloudinary.com/dvtkqsmh4/image/upload/w_80/v1485180777/p5lahhp26hhoaued8fip.jpg" class="img-responsive" /></a>
    </div>

</template>

<script>
    import vueStore from '../../store/store.js';
    import cartMixin from '../../mixins/cart-mixin.js';

    export default {
        mixins: [cartMixin],
        data: function () {
            return {
                selectedImage: '',
                zoomIsActive: false
            }
        },
        methods: {
            selectImage(image) {
                console.log("selectImage - todo: handle thumbs that are not connected to a color");
                console.log(image);

                this.selectedImage = image;
                if (image.Color != null && image.Color.length) {
                    vueStore.commit('setColor', image.Color)
                } else {
                    vueStore.commit('setColor', '')
                }
            },
            toggleZoom() {
                this.zoomIsActive = !this.zoomIsActive;
                if (this.zoomIsActive) {
                    document.body.classList.add("bike-zoom-active");
                } else {
                    document.body.classList.remove("bike-zoom-active");
                }
            },
            hasProductInCart(productId) {
                if (vueStore.state.cart && vueStore.state.cart.CartItems) {
                    return vueStore.state.cart.CartItems.findIndex(function (cartItem) {
                        return cartItem.Product.Id == productId;
                    }) > -1
                }
                return false;
            },
            showBundleVideoOrImage(imageOrVideo) {
                // SK temp hack for france
                if (imageOrVideo == 'image') {
                    document.getElementById("image-and-video-section").classList.remove('show-video-hide-image');
                } else {
                    document.getElementById("image-and-video-section").classList.add('show-video-hide-image');
                }
            },
            openGallery() {
                Window.triggerFirstProductThumbClick();
            }
        },
        computed: {
            product() {
                return vueStore.state.product
            },
            color() {
                return vueStore.state.color
            },
            storeActiveImage() {
                return vueStore.state.activeImage
            },
            activeImage() {
                // SK: some images are not linked to a color
                if (this.product.Product != undefined) {
                    if (this.storeActiveImage != null && this.storeActiveImage.CloudinaryImage != null) {
                        return this.storeActiveImage;
                    } else if (this.selectedImage != null && this.selectedImage.CloudinaryImage != null) {
                        return this.product.Product.CloudinaryImagesToPartnumbers.find(c => c.CloudinaryImage.PublicId == this.selectedImage.CloudinaryImage.PublicId)
                    } else if (this.product.Product.CloudinaryImagesToPartnumbers.find(c => (c.Color != undefined ? c.Color.toLowerCase() : '') == (this.color != undefined ? this.color.toLowerCase() : '')) != undefined) {
                        return this.product.Product.CloudinaryImagesToPartnumbers.find(c => (c.Color != undefined ? c.Color.toLowerCase() : '') == (this.color != undefined ? this.color.toLowerCase() : ''))
                    } else if (this.product.Product.CloudinaryImagesToPartnumbers.length > 0) {
                        return this.product.Product.CloudinaryImagesToPartnumbers[0];
                    } else {
                        return this.product.Product.Image;
                    }
                } else {
                    return '';
                }
            },
            enableCustomVideoImageSwitch() {
                // id 2435 -> langma-advanced-disc-1---edition-breakaway
                //return (this.product.Product != undefined && this.product.Product.Id == 2435 && this.product.Product.CountryId == 14);
                return false;
            }
        },
        created() {
            //this.interfaceTexts = JSON.parse(.interfacetexts);
        }
    }
</script>
